export const TOOLTIP_OFFSET = 14;

// The card sizes to its content (width: max-content) up to this cap; used here to
// estimate the flip point near the right viewport edge.
export const TOOLTIP_MAX_WIDTH = 320;
